import Modal from "@src/components/UIElements/Modal";
import { Image } from "@src/components/Image";
import React, { useEffect, useState } from "react";
import Button from "@src/components/UIElements/Button";
import styles from "./DynamicBundlingBottomSheet.module.scss";
import { useDispatch, useSelector } from "react-redux";
import * as actionCreator from "../../store/actions";
import { getAwsAssets } from "@src/utils";
import { useTranslation } from "react-i18next";
import toast from "react-hot-toast";
import {
  captureInterest,
  getDynamicCourseListAction,
  getDynamicCoursePriceAction,
  setDynamicBundlingSelectedAction,
  setSelectedStateAction,
} from "@src/components/Tabs/Overview/store/actions.js";
import { initialisePaymentService } from "@src/PaymentService";
import { newWebEngage } from "@src/utils/webEngageEvent";
import courseBundle from "@src/assets/coursebundle.gif";
import { executeQuery } from "@src/graphApis/graph";
import { getDynamicBundlingPricing } from "@src/graphApis";
import Loader from "../../../UIElements/Loader";
import MoneyBackBottomSheet from "../MoneyBackBottomSheet/MoneyBackBottomSheet";

const DynamicBundlingBottomSheet = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [showPriceDetails, setShowPriceDetails] = useState(false);
  const [showAnimation, setShowAnimation] = useState(false);
  const [isMoneyBackBottomSheetVisible, setIsMoneyBackBottomSheetVisible] = useState(false);
  const [selectedCourse, setSelectedCourse] = useState([]);
  const statesList = useSelector(
    (state) => state?.overviewReducer?.overViewDetails?.course?.states
  );
  const purchaseViaWhatsappV2 = useSelector(
    (state) =>
      state?.overviewReducer?.overViewDetails?.course?.purchaseViaWhatsappV2
  );
  const purchaseViaWhatsapp = useSelector(
    (state) =>
      state?.overviewReducer?.overViewDetails?.course?.purchaseViaWhatsapp
  );
  const enablePrefilledState = useSelector(
    (state) =>
      state?.overviewReducer?.overViewDetails?.course?.enablePrefilledState
  );
  const isComboActive = useSelector(
    (state) =>
      state?.overviewReducer?.overViewDetails?.course?.metaData?.isComboActive
  );
  const isDynamicBundling = useSelector(
    (state) => state?.bottomSheetReducer?.showDynamicBundlingBottomSheet
  );
  const dynamicCoursePrice = useSelector(
    (state) => state?.overviewReducer?.dynamicCoursePrice
  );
  const dynamicBundleList = useSelector(
    (state) => state?.overviewReducer?.dynamicBundleList
  );
  const token = useSelector((state) => state?.persistedDataReducer?.userToken);
  // console.log(statesList);
  const selectedState = useSelector(
    (state) => state?.overviewReducer?.stateSelected
  );
  const courseId = useSelector(
    (state) => state?.overviewReducer?.overViewDetails?.course?.metaData?.id
  );
  const dynamicCourse = useSelector(
    (state) => state?.overviewReducer?.dynamicCourse?.courseList
  );
  const dynamicBundlingLoading = useSelector(
    (state) => state?.overviewReducer?.dynamicBundlingLoading
  );
  const inputChangedHandler = (id) => {
    // console.log("value", e.target.value);

    if (dynamicBundleList?.includes?.(id)) {
      dispatch(
        setDynamicBundlingSelectedAction(
          dynamicBundleList.filter((courseId) => courseId !== id)
        )
      );
    } else {
      handleAnimation();
      dispatch(setDynamicBundlingSelectedAction([...dynamicBundleList, id]));
      // setSelectedCourse([...selectedCourse, id]);
    }
    // if (!enablePrefilledState) {
    //   window?.localStorage?.setItem("stateSelected", e.target.value);
    // }
    // dispatch(setSelectedStateAction(e.target.value));
  };
  const handleAnimation = () => {
    // debugger;
    setShowAnimation(true);
    setTimeout(() => {
      setShowAnimation(false);
    }, 1000);
  };
  const setAsDefaultHandler = (e) => {
    window?.webkit?.messageHandlers?.performAction?.postMessage(
      JSON.stringify({
        screen: "SELECT_DEFAULT_STATE",
        paramOne: selectedState,
      })
    );

    window?.mobile?.performAction?.(
      `SELECT_DEFAULT_STATE`,
      JSON.stringify({ paramOne: selectedState })
    );

    // console.log("first", e.target.checked);
  };
  const handleBuyNow = () => {
    // console.log(selectedState);
    // dispatch(actionCreator.showSelectDynamicBundlingBottomSheetAction(false));
    dispatch(actionCreator.dynamicBundlingPopupAction(true));
    initialisePaymentService();
  };
  useEffect(() => {
    dispatch(
      getDynamicCoursePriceAction({
        courseIds: [`${courseId}`, ...dynamicBundleList.map(String)],
        courseId: `${courseId}`,
      })
    );
  }, [dynamicBundleList]);
  useEffect(() => {
    dispatch(getDynamicCourseListAction(courseId));
  }, []);
  useEffect(() => {
      if(dynamicCourse && dynamicCourse.length && dynamicCourse.some(course => course.isAutoChecked)){
        const autoCheckedCourseIds = dynamicCourse.filter(course => course.isAutoChecked == 1).map(course => course.id)
        dispatch(setDynamicBundlingSelectedAction([...autoCheckedCourseIds]))
      }
  }, [dynamicCourse]);

  useEffect(() => {
    if(dynamicCourse?.length){
      const timeOutId = checkAndShowMoneyBackBottomSheet()
      return () => clearTimeout(timeOutId);
    }
}, [dynamicCourse]);

  function checkAndShowMoneyBackBottomSheet(){
    try {
      const isMoneyBackEnabled = dynamicCourse.some(course => course.isMoneyBack === 1)
      if(isMoneyBackEnabled){
        setIsMoneyBackBottomSheetVisible(true)
        const timeOutId = setTimeout(() => {
          setIsMoneyBackBottomSheetVisible(false)
        }, 5000);
        return timeOutId;
      }   
    } catch (error) {
      toast.error(
        t(
          "components.bottomSheets.components.DynamicBundlingBottomSheet.somethingWrongErrorText",
          "Something went wrong..."
        )
      );
    }
  }
  return (
    <>
      {isMoneyBackBottomSheetVisible ?
        <MoneyBackBottomSheet handleOnContinue={setIsMoneyBackBottomSheetVisible} handleClose = {setIsMoneyBackBottomSheetVisible}/>
        :
    <div className={styles.AllStates}>
      <Modal
        showModal={isDynamicBundling}
        handleClose={() => {
          dispatch(
            actionCreator.showSelectDynamicBundlingBottomSheetAction(false)
          );
        }}
        header={
          <div className={styles.AllStates__header}>
            {/* <Image
              src={getAwsAssets("locationIcon.svg", "bottomSheets")}
              alt={t(
                "components.bottomSheets.components.selectStateBottomSheet.locationIcon",
                "locationIcon"
              )}
              width="28px"
              height="28px"
            /> */}
            {showPriceDetails ? (
              <div
                onClick={() => {
                  setShowPriceDetails(false);
                }}
              >
                <Image
                  height={24}
                  width={24}
                  src={getAwsAssets("fi_arrow-left.svg", "bottomSheets")}
                />
              </div>
            ) : null}{" "}
            {showPriceDetails
              ? t(
                  "components.bottomSheets.components.DynamicBundlingBottomSheet.priceBreakup",
                  "Price Breakup"
                )
              : t(
                  "components.bottomSheets.components.DynamicBundlingBottomSheet.buyTogetherHeading",
                  "Buy together & save more"
                )}
          </div>
        }
      >
        <div className={styles.AllStates__States}>
          {showPriceDetails ? (
            <div className={styles.AllStates__States__Pricebox}>
              <div className={styles.AllStates__States__Pricebox__items}>
                {!!dynamicCoursePrice?.coupons?.length && dynamicCoursePrice?.coupons?.[0]?.dynamicData?.map((values) => (
                  <>
                    {values?.map((valueDetails) => (
                      <div
                        className={
                          styles.AllStates__States__Pricebox__items__flexRow
                        }
                        key={valueDetails?.label}
                      >
                        <>
                          <div
                            className={
                              styles.AllStates__States__Pricebox__items__leftKey
                            }
                          >
                            {valueDetails?.label}
                          </div>
                          <div
                            className={
                              styles.AllStates__States__Pricebox__items__rightKey
                            }
                            style={{
                              color:
                                valueDetails?.value.length &&
                                valueDetails?.value[0] == "-"
                                  ? "#08BD80"
                                  : "",
                            }}
                          >
                            {valueDetails?.value}
                          </div>
                        </>
                      </div>
                    ))}
                    <div
                      className={
                        styles.AllStates__States__Pricebox__items__dashedborder
                      }
                    ></div>
                  </>
                ))}

                {!!dynamicCoursePrice?.coupons?.length && dynamicCoursePrice?.coupons?.[0]?.dynamicChargesData?.map(
                  (dynamicData) => (
                    <>
                      <div
                        className={
                          styles.AllStates__States__Pricebox__items__flexRow
                        }
                      >
                        <div
                          className={
                            styles.AllStates__States__Pricebox__items__leftKey
                          }
                        >
                          {dynamicData?.label}
                        </div>
                        <div
                          className={
                            styles.AllStates__States__Pricebox__items__rightKey
                          }
                        >
                          {dynamicData.label === 'Platform Fee' ? (
                                <>
                                  <span style={{textDecoration: 'line-through', color: 'grey'}}>{dynamicData?.strikedValue}</span>
                                  &nbsp;&nbsp;
                                </>
                          ) : null}
                          {dynamicData?.value}
                        </div>
                      </div>
                    </>
                  )
                )}
                {/* </div> */}
                {/* <div
                  className={styles.AllStates__States__Pricebox__items__flexRow}
                >
                  <div
                    className={
                      styles.AllStates__States__Pricebox__items__leftKey
                    }
                  >
                    SBI Clerk 2024
                  </div>
                  <div
                    className={
                      styles.AllStates__States__Pricebox__items__rightKey
                    }
                    style={{ color: "#08BD80" }}
                  >
                    ₹4,000/-
                  </div>
                </div> */}
              </div>
            </div>
          ) : (
            <div className={styles.AllStates__States__StateList}>
              {dynamicCourse?.map((data) => (
                <div
                  className={styles.AllStates__States__StateList__item}
                  key={data?.id}
                >
                  <input
                    type="checkbox"
                    name="selectedState"
                    // id={"d"}
                    // value={"dfasf"}
                    checked={dynamicBundleList?.includes(data?.id)}
                    onChange={() => inputChangedHandler(data?.id)}
                  />
                  <div
                    className={
                      styles.AllStates__States__StateList__item__courseBoxBorder
                    }
                    onClick={() => {
                      inputChangedHandler(data?.id);
                    }}
                    style={
                      dynamicBundleList?.includes(data?.id)
                        ? { border: "1px solid #009AE0" }
                        : {}
                    }
                  >
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row-reverse",
                        paddingBottom: !data?.isComboFeaturedCourse
                          ? "12px"
                          : "",
                      }}
                    >
                      {data?.isComboFeaturedCourse ? (
                        <div
                          className={
                            styles.AllStates__States__StateList__item__courseBoxBorder__tagTopRight
                          }
                        >
                          Most Bought Together
                        </div>
                      ) : null}
                    </div>

                    <div
                      className={
                        styles.AllStates__States__StateList__item__courseBox
                      }
                    >
                      <Image width="71px" height="53px" src={data?.imageUrl} />
                      <div
                        className={
                          styles.AllStates__States__StateList__item__infoContainer
                        }
                      >
                        {data?.courseTags?.length > 0 ? (
                          <div
                            className={
                              styles.AllStates__States__StateList__item__tagContainer
                            }
                          >
                            {data?.courseTags.map((tags) => (
                              <div
                                key={tags?.text}
                                className={
                                  styles.AllStates__States__StateList__item__tag
                                }
                              >
                                {tags?.text}
                              </div>
                            ))}
                          </div>
                        ) : null}

                        <p>{data?.name}</p>
                        <div
                          className={
                            styles.AllStates__States__StateList__item__validityContainer
                          }
                        >
                          <Image
                            height={12}
                            width={12}
                            src={getAwsAssets(
                              "greyClockIcon.svg",
                              "bottomSheets"
                            )}
                          />
                          <p>{data?.label?.heading}</p>
                        </div>
                        <div
                          className={
                            styles.AllStates__States__StateList__item__coursePrice
                          }
                        >
                          <p>{data?.finalPriceText}</p>{" "}
                          {data?.discountText?.length ? (
                            <>
                              <span>{data?.priceText}</span>
                              <div
                                className={
                                  styles.AllStates__States__StateList__item__coursePrice__offerTag
                                }
                              >
                                Extra{" "}
                                <div
                                  className={
                                    styles.AllStates__States__StateList__item__coursePrice__offerTag__offerPrice
                                  }
                                >
                                  {data?.discountText}
                                </div>{" "}
                                Off
                              </div>
                            </>
                          ) : null}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
        {/* {selectedState ? ( */}

        <div className={styles.AllStates__ModalFooter}>
          {dynamicCoursePrice?.priceBottom?.extraDiscount ? (
            <div className={styles.AllStates__ModalFooter__offerStrip}>
              🎉 You are saving{" "}
              <span> {dynamicCoursePrice?.priceBottom?.extraDiscount} </span> on
              this combo 🎉
            </div>
          ) : null}

          <div className={styles.AllStates__ModalFooter__FlexRow}>
            <div className={styles.AllStates__ModalFooter__totalPrice}>
              <p className={styles.AllStates__ModalFooter__PriceBottom}>
                {dynamicCoursePrice?.priceBottom?.finalPrice}
              </p>
              <div
                onClick={() => setShowPriceDetails(!showPriceDetails)}
                className={styles.AllStates__ModalFooter__viewPriceDetails}
              >
                {showPriceDetails ? "Hide price breakup" : "View price breakup"}
                <Image
                  height={16}
                  width={16}
                  src={getAwsAssets(
                    showPriceDetails
                      ? "blueArrowDownOutline.svg"
                      : "blueArrowUpOutline.svg",
                    "bottomSheets"
                  )}
                />
              </div>
            </div>

            <Button
              outline={true}
              customClassName={styles.AllStates__ModalFooter__Button}
              // className={styles.AllStates__ModalFooter__Button}
              onClick={() => handleBuyNow()}
              style={
                dynamicBundleList.length
                  ? { backgroundColor: "#009AE0", color: "white" }
                  : {}
              }
            >
              {dynamicBundlingLoading ? (
                <Loader
                  colored={dynamicBundleList.length ? false : true}
                  small
                />
              ) : dynamicBundleList.length ? (
                t(
                  "components.bottomSheets.components.DynamicBundlingBottomSheet.ProcedeToPay",
                  "Proceed to Pay"
                )
              ) : (
                t(
                  "components.bottomSheets.components.DynamicBundlingBottomSheet.SkipAndContinue",
                  "Skip & continue"
                )
              )}
            </Button>
          </div>
        </div>
        {showAnimation ? (
          <img
            style={{ position: "absolute", top: 0 }}
            src={courseBundle.src}
            width={"100%"}
            height={"100%"}
          />
        ) : null}

        {/* // ) : null} */}
      </Modal>
    </div>
    }
    </>
  );
};

export default DynamicBundlingBottomSheet;
